import { useState, useEffect, useCallback } from 'react';
import Board from './Board.js';
import { DIFFICULTIES, difficultyOf } from './difficulty.js';

function PlayTab({ active = true, replayGame = null, onShowUnlimited = null, unlimited = false, onTutorialChange = () => {}, onShowHelp = () => {} }) {
  const [difficulty, setDifficulty] = useState("Medium");
  // Board owns the lesson, so it says when the chrome goes away. App needs it
  // too, for the nav bar, so it passes through on its way up.
  const [teaching, setTeaching] = useState(false);
  const handleTutorialChange = useCallback((active) => {
    setTeaching(active);
    onTutorialChange(active);
  }, [onTutorialChange]);

  const handleDifficultyChange = (e) => {
    setDifficulty(e.target.value);
  };

  // Match the mode to whatever board is being replayed, so "New Game" stays in that mode
  useEffect(() => {
    if (replayGame) {
      setDifficulty(difficultyOf(replayGame.getNumbers())?.name ?? "Medium");
    }
  }, [replayGame]);

  return (
    <>
      {/* Gone rather than greyed out mid-lesson: the board is the only thing
          to look at, and a dead control is still something to look at */}
      {!teaching && (
        <div className="difficulty-selector invisible-hud">
          {/* No label: the option already reads "Classic", and a form label
              in front of a one-control card is the thing that makes it look
              like a settings row instead of a piece of the game */}
          <select value={difficulty} onChange={handleDifficultyChange} aria-label="Mode">
            {DIFFICULTIES.map(({ name, label }) => (
              <option key={name} value={name}>{label}</option>
            ))}
          </select>
          {/* Sharing the selector's card rather than taking a third slot in the
              bar - the streak sits opposite, and three objects collide at
              375px. A question mark, not an "i": what is behind it is the
              rules and the lesson, which is help rather than information. */}
          <span className="difficulty-divider" />
          <button className="help-btn" onClick={onShowHelp} aria-label="How to play">?</button>
        </div>
      )}

      <Board difficulty={difficulty} active={active} startingGame={replayGame} onShowUnlimited={onShowUnlimited} unlimited={unlimited} onTutorialChange={handleTutorialChange} />

    </>
  );
}

export default PlayTab;
